import Link from 'next/link';
import styles from './TestEds.module.scss';

export const AttachSert = () => {
    return (
        <div className={styles.container}>
            <div className={styles.panel}>
                <h1>Прикрепление ЭП к профилю</h1>

                <p>
                    При получении электронной подписи (ЭП) удостоверяющий центр
                    (УЦ) выдал Вам сертификат публичного ключа.
                </p>

                <p>
                    Перед прикреплением ЭП убедитесь в том, что{' '}
                    <Link href="/test_eds/">
                        <a>настройки ЭП</a>
                    </Link>{' '}
                    на Вашем компьютере верны, и сертификат, который Вы
                    собираетесь прикрепить действителен.
                </p>

                <ol>
                    <li>
                        После прохождения процедуры
                        <Link href="/auth/registration">
                            <a title="Пройти регистрацию">{' регистрации '}</a>
                        </Link>
                        выполните{' '}
                        <Link href="/auth/login">
                            <a title="Перейти на страницу входа">{' вход '}</a>
                        </Link>
                        в систему используя логин и пароль.
                        <img
                            src="/assets/dummy-data/instructions/login.png"
                            alt="Вход в систему по логину и паролю"
                            title="Вход в систему по логину и паролю"
                        />
                    </li>
                    <li>
                        После входа в Личный кабинет перейдите в раздел меню
                        <strong>{' Профиль организации '}</strong>
                        и во вкладке «Основное» в блоке «Электронная подпись»
                        нажмите «Редактировать».
                        <img
                            src="/assets/dummy-data/instructions/go_to_profile.png"
                            alt="Перейдите в профиль организации"
                            title="Перейдите в профиль организации"
                        />
                    </li>
                    <li>
                        В появившемся модальном окне в верхнем селекторе выбрать
                        нужную ЭП и нажать кнопку «Проверить». В случае успешной
                        проверки отметить чекбокс «Подтверждаю правильность
                        данных и даю своё согласие на отправку» внизу формы и
                        нажать кнопку «Прикрепить».
                        <img
                            src="/assets/dummy-data/instructions/press_change_eds.png"
                            alt="Прикрепите новую ЭП"
                            title="Прикрепите новую ЭП"
                        />
                    </li>
                    <li>
                        Подтвердите успешное прикрепление
                        <img
                            src="/assets/dummy-data/instructions/successConfirm.png"
                            alt="Подтвердите успешное прикрепление"
                            title="Подтвердите успешное прикрепление"
                        />
                    </li>
                    <li>
                        В случае отсутствия селектора или если он пуст,
                        рекомендуем попробовать использовать Google Chrome,
                        Opera или Mozilla Firefox с установкой расширения
                        CryptoPro BrowserPlaguin для данного браузера. В правом
                        верхнем углу нажать на вертикальные точки, далее
                        «Настройки» {'>'} «Дополнительные инструменты»
                        {' >'} «Расширения».
                        <img
                            src="/assets/dummy-data/instructions/extensions.png"
                            alt="Расширения"
                            title="Расширения"
                        />
                    </li>
                    <li>
                        В списке плагинов найти расширение СryptoPro Extension
                        for CAdES Browser Plug-in и поставить статус «Включено».
                        <img
                            src="/assets/dummy-data/instructions/extension_switch_on.png"
                            alt="поставить статус Включено"
                            title="поставить статус Включено"
                        />
                    </li>
                    <li>
                        Если расширение СryptoPro Extension for CAdES Browser
                        Plug-in отсутсвует в списке, необходимо его установить,
                        кликнув по его наименованию в списке в разделе
                        <Link href="/test_eds/">
                            <a title="Перейти на страницу проверки ЭП">
                                {' http://estp.ru/test_eds/'}
                            </a>
                        </Link>
                        .
                        <img
                            src="/assets/dummy-data/instructions/test_eds_page_extension.png"
                            alt="Перейти на страницу проверки ЭП"
                            title="Перейти на страницу проверки ЭП"
                        />
                    </li>
                    <li>
                        После перехода на сайт
                        <a
                            href="https://www.cryptopro.ru/products/cades/plugin"
                            rel="nofollow noopener noreferrer"
                            target="_blank"
                        >
                            {' https://www.cryptopro.ru/products/cades/plugin '}
                        </a>
                        установите КриптоПро ЭЦП браузер плагин
                        <img
                            src="/assets/dummy-data/instructions/crypto_pro_site.png"
                            alt="установите КриптоПро ЭЦП браузер плагин"
                            title="установите КриптоПро ЭЦП браузер плагин"
                        />
                    </li>
                    <li>
                        Далее необходимо установить на примере браузера Chrome
                        соответствующее расширение для используемого браузера
                        <img
                            src="/assets/dummy-data/instructions/load_chrome_extension.png"
                            alt="установить расширение"
                            title="установить расширение"
                        />
                    </li>
                    <li>
                        Пройдя по ссылке установить необходимый плагин
                        <img
                            src="/assets/dummy-data/instructions/plugin_install_button.png"
                            alt="установить необходимый плагин"
                            title="установить необходимый плагин"
                        />
                    </li>
                    <li>
                        Подтвердите установку плагина, нажав «Установить
                        расширение»
                        <img
                            src="/assets/dummy-data/instructions/install_extension_button.png"
                            alt="Подтвердите установку плагина"
                            title="Подтвердите установку плагина"
                        />
                    </li>
                    <li>
                        Если после проверки ЭП высветилась ошибка, то необходимо
                        действовать согласно инструкциям из текста ошибки или
                        обратиться в удостоверяющий центр, выдававший КЭП. Также
                        можно обратиться в службу технической поддержки ЕСТП за
                        более подробным описанием.
                        <img
                            src="/assets/dummy-data/instructions/eds_error.png"
                            alt="обратиться в службу технической поддержки"
                            title="обратиться в службу технической поддержки"
                        />
                        Техническая поддержка изучит отправленные данные и, если
                        это возможно, прикрепит подпись к личному кабинету
                        вручную. По факту исполнения обращения пользователю
                        будет выслано письмо на e-mail
                    </li>
                </ol>
            </div>
        </div>
    );
};
